<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">费用明细表</span>
		</div>
		<div class="margin-right-left margin-top">
			<DatePicker v-model="accountDate" style="width: 160px" :clearable="false" format="YYYY" type="year" placeholder="选择年度" :showTime="false"></DatePicker>
			<Checkbox v-model="params.showZero" style="margin-left: 10px;">展示发生额为0的科目</Checkbox>
			<Checkbox v-model="params.fullName">明细科目显示全称</Checkbox>
			<div class="float-right">
				<Button color="primary" icon="fa fa-search" :loading="loading" @click="doSearch">查询</Button>
				<Button icon="fa fa-refresh" @click="loadList">刷新</Button>
				<Button icon="fa fa-print" @click="print">打印</Button>
			</div>
		</div>
		<div class="h-panel-body" style="overflow-x: auto;">
			<table class="cus-table" id="feeTable">
				<thead class="header">
				<tr>
					<td rowspan="2">科目编码</td>
					<td rowspan="2">科目名称</td>
					<td colspan="12" class="text-center">本年发生额</td>
					<td rowspan="2">年度合计</td>
				</tr>
				<tr>
					<td v-for="m in 12" :key="m" class="text-center">{{year}}年{{String(m).padStart(2,'0')}}月</td>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(item,index) in displayList" :key="index">
					<td :style="{'padding-left':((item.level-1)*12)+'px'}">{{item.code}}</td>
					<td :style="{'padding-left':((item.level-1)*12)+'px'}">{{item.name}}</td>
					<td class="text-right" v-for="m in 12" :key="m">{{item['m'+m] | numFormat}}</td>
					<td class="text-right" :class="{tip:item.yearTotal<0}"><strong>{{item.yearTotal | numFormat}}</strong></td>
				</tr>
				<tr v-if="!displayList.length">
					<td colspan="14" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
		</div>
	</app-content>
</template>

<script>
	import manba from "manba";

	export default {
		name: "ExpenseDetailReport",
		data() {
			return {
				loading: false,
				accountDate: manba().format('YYYY'),
				params: {
					showZero: true,
					fullName: true
				},
				dataList: []
			};
		},
		computed: {
			year() {
				return Number(String(this.accountDate).substring(0, 4));
			},
			displayList() {
				if (this.params.showZero) {
					return this.dataList;
				}
				return this.dataList.filter(item => Number(item.yearTotal) !== 0);
			}
		},
		watch: {
			accountDate() {
				this.loadList();
			}
		},
		methods: {
			doSearch() {
				this.loadList();
			},
			loadList() {
				this.loading = true;
				this.$api.report.fee.detail({
					year: this.year,
					codePrefix: '5'
				}).then(({data}) => {
					this.dataList = data;
					this.loading = false;
				});
			},
			print() {
				const html = document.getElementById('feeTable').outerHTML;
				const win = window.open('', '_blank');
				win.document.write('<html><head><title>费用明细表</title><style>table{border-collapse:collapse;width:100%;font-size:11px}td{border:1px solid #999;padding:3px 6px;text-align:right}.header td{background:#eee;text-align:center;font-weight:bold}.tip{background:#FFEEEF}td:first-child,td:nth-child(2){text-align:left}</style></head><body><h2 style="text-align:center">' + this.year + ' 年度费用明细表</h2>' + html + '</body></html>');
				win.document.close();
				win.print();
			}
		},
		created() {
			this.loadList();
		}
	}
</script>

<style scoped lang="less">
	.cus-table {
		width: 100%;
		border-collapse: collapse;

		td {
			padding: 0 8px;
			border: 1px solid #e2e2e2;
			font-size: 12px;
			height: 32px;
			white-space: nowrap;

			&.tip {
				background-color: #FFEEEF;
			}
		}

		tbody tr:nth-child(even) {
			background-color: #f8fbf8;
		}

		tbody tr:hover {
			background-color: #F0F6FF;
		}

		.header {
			td {
				background-color: #F5F5F5;
				text-align: center;
				font-weight: bold;
				height: 35px;
			}
		}
	}
</style>
